"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccordionContext = exports.AccordionContextProvider = void 0;
var react_1 = require("react");
var AccordionContext = react_1.createContext({
    expandedState: {},
    toggleItem: function () { return null; },
});
exports.AccordionContextProvider = AccordionContext.Provider;
var useAccordionContext = function () { return react_1.useContext(AccordionContext); };
exports.useAccordionContext = useAccordionContext;
